var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrrowLeftFilled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4224 6.11839C11.9938 6.11839 11.5716 6.2588 11.2367 6.53069L6.5965 10.2996C6.22521 10.6001 6.01227 11.033 6.01227 11.4855C6.01227 11.9381 6.22521 12.371 6.59559 12.6715L11.2367 16.4395C11.79 16.8903 12.5789 16.9806 13.2469 16.672C13.8366 16.3984 14.2024 15.8555 14.2024 15.2535L14.2024 7.71753C14.2024 7.11562 13.8366 6.57273 13.2469 6.29905C12.9839 6.17742 12.7018 6.11839 12.4224 6.11839Z",
    fill: "#231F20"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2844_6986",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 9,
    height: 11
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4224 6.11839C11.9938 6.11839 11.5716 6.2588 11.2367 6.53069L6.5965 10.2996C6.22521 10.6001 6.01227 11.033 6.01227 11.4855C6.01227 11.9381 6.22521 12.371 6.59559 12.6715L11.2367 16.4395C11.79 16.8903 12.5789 16.9806 13.2469 16.672C13.8366 16.3984 14.2024 15.8555 14.2024 15.2535L14.2024 7.71753C14.2024 7.11562 13.8366 6.57273 13.2469 6.29905C12.9839 6.17742 12.7018 6.11839 12.4224 6.11839Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2844_6986)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.8404,
    height: 21.465,
    transform: "matrix(1 0 0 -1 0.0972595 22.2181)",
    fill: "#97144D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrrowLeftFilled);
export default __webpack_public_path__ + "static/media/arrrow-left-filled.c75cdd5fe6561b9d1d754acc712c4e8f.svg";
export { ForwardRef as ReactComponent };